import SessionMessage from "../models/SessionMessage";

const sessionMessage = (sessionMessage = new SessionMessage(), action: any) => {
  switch (action.type) {
    // TODO: may want message state etc
    default:
      return sessionMessage;
  }
};

export default sessionMessage;
